import React, {FC} from 'react';
import {ItemProps} from '../../types';
import ValidationError from '../ValidationError';

const Preview: FC<ItemProps> = (
    props
) => {

    return (
        <>
            {props.formItem.itemOptions?.preview && (
                <div>{props.formItem.itemOptions.preview(props)}</div>
            )}
            <ValidationError error={props.validation as any} formItem={props.formItem}/>

        </>
    );
};

export default Preview;
